.notification_group {
  margin: 6px;
  bottom: 0;
  right: 0;
  flex-wrap: wrap-reverse;
  align-items: flex-end;
}
